import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import SrPDView from './PumpSpareDomestic/View';
import SrPIView from './PumpSpareInternational/View';
import SalesMDView from './ManufacturingDomestic/View';
import SrMIView from './ManufacturingInternational/View';

function SrView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [salesreturntype, setsalesreturntype] = useState('');
  const [salesreturncategory, setsalesreturncategory] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}salesReturn/findById/${id}`, {
          headers: authHeader(),
        });
        setsalesreturntype(response.data.salesreturntype);
        setsalesreturncategory(response.data.salesreturncategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (salesreturntype === 'Pump Spare') {
      if (salesreturncategory === 'Domestic') {
        return <SrPDView />;
      } else if (salesreturncategory === 'International') {
        return <SrPIView />;
      }
    } else if (salesreturntype === 'Manufacturing') {
      if (salesreturncategory === 'Domestic') {
        return <SalesMDView />;
      } else if (salesreturncategory === 'International') {
        return <SrMIView />;
      }
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW SALES REJECTION</h6>
          <div className="view-buttons">
            {/* Delete and Edit buttons commented out */}
            <Link to={`/srindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Type:</Form.Label>
                <Form.Select disabled value={salesreturntype} onChange={(e) => setsalesreturntype(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Category:</Form.Label>
                <Form.Select disabled value={salesreturncategory} onChange={(e) => setsalesreturncategory(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default SrView;
